//* Import components
import {
  Box,
  Typography,
  Avatar,
  Stack,
  useTheme,
  IconButton,
} from "@mui/material";
import {
  LinkedIn,
  Instagram,
  Telegram,
  GitHub,
  Language,
} from "@mui/icons-material";

export default function Team() {
  //Hooks
  const theme = useTheme();

  const teamMembers = [
    {
      name: "عطیه آدین",
      position: "بنیان‌گذار و مدیر خلاقیت",
      bio: "هدایت مسیر برند و توسعه ایده‌های خلاقانه با تمرکز بر ساخت تجربه‌های ماندگار.",
      avatar: "/media/team/aa.png",
      socials: {
        instagram: "https://instagram.com/adinzone",
      },
    },
    {
      name: "امیررضا میرشفیعی",
      position: "مهندس فول‌استک",
      bio: "توسعه سیستم‌های وب، معماری نرم‌افزار و ساخت محصولات دیجیتال قابل اعتماد.",
      avatar: "/media/team/am.png",
      socials: {
        github: "https://github.com/AmirrezaMirshafiee",
        linkedin: "https://www.linkedin.com/in/amirreza-mirshafiee-a029a025b/",
        telegram: "https://t.me/mirshafieea",
      },
    },
    {
      name: "کیانا کدیور",
      position: "مهندس فرانت‌اند",
      bio: "طراحی رابط‌های مدرن و تجربه کاربری برای ساخت محصولات دیجیتال جذاب.",
      avatar: "/media/team/kk.png",
      socials: {
        github: "https://github.com/KianaKadivar",
        linkedin: "https://www.linkedin.com/in/kianathekad/",
        telegram: "https://t.me/KianaTheKad",
      },
    },
    {
      name: "پوریا صبوری",
      position: "مهندس فول‌استک",
      bio: "توسعه محصولات وب و تبدیل ایده‌ها به راهکارهای واقعی و مقیاس‌پذیر.",
      avatar: "/media/team/ps.png",
      socials: {
        github: "https://github.com/pouriya-3a",
        linkedin: "https://www.linkedin.com/in/pouriya3a",
        telegram: "https://t.me/pouriya_3a",
        website: "https://pourifolio.ir",
      },
    },
  ];
  const SocialIcon = ({ type, url }) => {
    const icons = {
      github: <GitHub />,
      linkedin: <LinkedIn />,
      instagram: <Instagram />,
      telegram: <Telegram />,
      website: <Language />,
    };

    return (
      <IconButton
        component="a"
        href={url}
        target="_blank"
        size="small"
        sx={{
          width: 32,
          height: 32,
          padding: 0,
          background: "rgba(255,255,255,.05)",
          color: "text.secondary",
          transition: ".3s",
          "&:hover": {
            color: "secondary.main",
            background: "rgba(0,229,255,.15)",
            transform: "translateY(-3px)",
          },
        }}
      >
        {icons[type]}
      </IconButton>
    );
  };

  return (
    <Stack
      spacing={5}
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <Box textAlign="center">
        <Box
          sx={{
            width: 55,
            height: 30,
            mx: "auto",
            mb: 2,
            borderRadius: 10,
            background: "rgba(92,107,192,.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            color: "secondary.main",
          }}
        >
          ✦
        </Box>
        <Typography fontSize="2rem" fontWeight={800}>
          تیم حرفه‌ای ما
        </Typography>
        <Typography color="text.secondary" mt={1}>
          متخصصینی که مسیر رشد شما را می‌سازند
        </Typography>
      </Box>
      {/* Team */}
      <Box
        sx={{
          width: "100%",
          minWidth: 0,
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 3,

          "@media (min-width:900px)": {
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          },
        }}
      >
        {teamMembers.map((member) => (
          <Box
            key={member.name}
            sx={{
              minHeight: 150,
              borderRadius: "100px",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 0,
              py: 1.5,
              background:
                "linear-gradient(90deg,rgba(255,255,255,.07),rgba(255,255,255,.025))",
              // border: '1px solid rgba(255,255,255,.1)',
              transition: "all .35s",
              "&:hover": {
                transform: "translateY(-6px)",
                borderColor: theme.palette.primary.main,
                boxShadow: `0 20px 45px ${theme.palette.primary.main}35`,
              },
            }}
          >
            {/* Avatar */}
            <Box
              sx={{
                width: { xs: 100, md: 126 },
                height: { xs: 100, md: 126 },
                flexShrink: 0,
                mr: 2.5,
                borderRadius: "50%",
                padding: "3px",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  inset: 0,
                  borderRadius: "50%",
                  background: `conic-gradient(
                    ${theme.palette.primary.main},
                    ${theme.palette.secondary.main},
                    ${theme.palette.info.main},
                    ${theme.palette.primary.main},
                    ${theme.palette.info.light},
                    ${theme.palette.secondary.main},
                    ${theme.palette.primary.main}
                  )`,
                  animation: "rotateBorder 2.5s linear infinite",
                },
                "@keyframes rotateBorder": {
                  "0%": {
                    transform: "rotate(0deg)",
                  },

                  "100%": {
                    transform: "rotate(360deg)",
                  },
                },

                "&::after": {
                  content: '""',
                  position: "absolute",
                  inset: "3px",
                  borderRadius: "50%",
                  background: "#121212",
                },
              }}
            >
              <Avatar
                src={member.avatar}
                alt={member?.name || "adinzone team"}
                sx={{
                  position: "relative",
                  zIndex: 2,
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                }}
              />
            </Box>
            {/* Content */}
            <Box>
              <Typography fontSize="1.05rem" fontWeight={800}>
                {member.name}
              </Typography>
              <Typography
                color="secondary.main"
                fontWeight={600}
                fontSize=".75rem"
              >
                {member.position}
              </Typography>

              <Typography
                color="text.secondary"
                fontSize=".75rem"
                lineHeight={1.7}
                mt={1}
                sx={{
                  maxWidth: 260,
                }}
              >
                {member.bio}
              </Typography>

              <Stack direction="row" gap={0.8} mt={1.5}>
                {Object.entries(member.socials).map(([type, url]) => (
                  <SocialIcon key={type} type={type} url={url} />
                ))}
              </Stack>
            </Box>
          </Box>
        ))}
      </Box>
    </Stack>
  );
}
